<template>
  <label class="button button--upload" :for="id">
    <div class="input-container">
      <input :id="id" type="file" v-bind="$attrs" v-on="$listeners" />
    </div>
    <slot></slot>
  </label>
</template>

<style lang="scss" scoped>

label.button {
  @extend %text-style--button;
  background-color: buttonface;
  color: buttontext;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

.input-container {
  overflow: hidden;
  width: 0;
  height: 0;
}

input[type=file] {
  opacity: 0;
  width: 0;
  height: 0;
}

</style>

<script>
import { v4 as uuid } from 'uuid'

export default {
  inheritAttrs: false,
  props: {
    id: {
      default: () => uuid()
    }
  }
}
</script>
